<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Topic Model Form
        </v-card-title>
        <v-tabs
        grow
        icons-and-text
        dark
        slider-color="grey lighten-4"
        color="primary"
        v-model="step">
          <v-tab ripple>
            General Info
          </v-tab>
          <v-tab ripple :disabled="isNew">
            Topics
          </v-tab>
        </v-tabs>
        <v-card-text>
          <v-tabs-items v-model="step">
            <v-tab-item class="mt-4">
                <form>
                  <v-layout row>
                    <v-flex xs6>
                      <v-text-field
                      disabled
                      v-model="item.id"
                      label="ID">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                      v-model="item.name"
                      v-validate="'required|min:3'"
                      data-vv-name="title"
                      :error-messages="errors.collect('title')"
                      label="Title">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-select
                      label="Language"
                      :items="languages"
                      v-validate="'required'"
                      data-vv-name="language"
                      :error-messages="errors.collect('language')"
                      v-model="item.language">
                      </v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                      label="Dataset"
                      :items="datasets"
                      v-validate="'required'"
                      data-vv-name="dataset"
                      :error-messages="errors.collect('dataset')"
                      v-model="item.dataset">
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6 v-if="false">
                      <v-select
                      label="Model Type"
                      :items="topicModelTypeCollection"
                      item-text="name"
                      item-value="id"
                      data-vv-name="type"
                      :error-messages="errors.collect('type')"
                      v-model="item.type"
                      :disabled="true">
                      </v-select>
                    </v-flex>
                    <v-flex xs6 v-if="item.type===1">
                      <v-select
                      label="Annotation Work"
                      :items="annotationWorks"
                      v-validate="annotationWorkValidationRules"
                      data-vv-name="annotation work"
                      :error-messages="errors.collect('annotation work')"
                      v-model="item.annotationWork">
                      </v-select>
                    </v-flex>
                  </v-layout>
                </form>
            </v-tab-item>
            <v-tab-item>
                <v-toolbar flat color="white">
                  <h4>Topics</h4>
                  <v-spacer></v-spacer>
                  <v-btn medium depressed flat icon color="primary" :to="`/topic-models/${item.id}/topics/add`">
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-data-table
                :headers="topicHeaders"
                :items="item.topics"
                :loading="topicListLoading"
                :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                >
                  <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ topicModelTypeDictionary[props.item.topicModelType] }}</td>

                    <td class="text-xs-right">
                              <v-tooltip bottom color="accent">
                                <v-icon
                                  class="mr-2"
                                  color="accent"
                                  slot="activator"
                                  @click="$router.push(`/topic-models/${item.id}/topics/${props.item.id}/edit`)"
                                >
                                  edit
                                </v-icon>
                                <span>Edit Item</span>
                              </v-tooltip>
                              <v-tooltip bottom color="error">
                                <v-icon
                                  color="error"
                                  slot="activator"
                                  @click="deleteDialog = true; itemToDelete = props.item;"
                                >
                                  delete
                                </v-icon>
                                <span>Delete Item</span>
                              </v-tooltip>
                    </td>
                  </template>
                </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading" v-show="step == 0">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
    <v-dialog
          v-model="deleteDialog"
          max-width="500"
        >
          <v-card>
            <v-card-title class="headline">Delete topic</v-card-title>
            <v-card-text>
              Are you sure to delete this topic?
            </v-card-text>
            <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                flat
                depressed
                :disabled="deleteLoading"
                @click="deleteDialog = false; itemToDelete = {};"
              >
                Cancel
              </v-btn>
              <v-btn
                color="error"
                depressed
                class="white--text"
                :loading="deleteLoading"
                :disabled="deleteLoading"
                @click.native="deleteTopic()"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    stepProp: {
      type: Number,
      required: false,
      default: 0
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
    }
    this.step = this.stepProp
    this.axios.get(`/datasets`)
      .then(response => {
        this.datasets = response.data.map((ds) => { return {text: ds.name, value: ds.id} })
        this.axios.get('/annotation-works', {
          params: {
            topic_model_id: this.id
          }
        })
          .then(response => {
            this.annotationWorks = response.data.map((aw) => { return {text: aw.name, value: aw.id} })
            this.axios.get(`/languages`)
              .then(response => {
                this.languages = response.data.map((ds) => { return {text: ds.name, value: ds.id} })
                if (!this.isNew) {
                  this.fetchTopicModelItem()
                }
              })
              .catch(error => {
                this.handleAxiosError(error)
              })
          })
      })
      .catch(error => {
        this.handleAxiosError(error)
      })
  },
  data () {
    return {
      topicHeaders: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Method', sortable: false, value: 'matchingMethod'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      item: {
        id: '',
        language: '',
        name: '',
        dataset: '',
        topics: [],
        type: 0,
        annotationWork: undefined
      },
      datasets: [],
      annotationWorks: [],
      saveLoading: false,
      step: 0,
      itemToDelete: {},
      deleteLoading: false,
      deleteDialog: false,
      topicListLoading: false,
      languages: []
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    annotationWorkValidationRules () {
      let rule = ''
      if (this.item.type === 1) {
        rule = 'required'
      }
      return rule
    },
    ...mapState({
      topicModelTypeCollection: state => state.configurations.topicModelTypes,
      topicModelTypeDictionary: state => state.configurations.topicModelTypesDictionary
    })
  },
  watch: {
    id (val) {
      this.item.id = val
    },
    stepProp (val) {
      this.step = val
    },
    item: {
      deep: true,
      handler (newValue) {
        if (newValue.type !== 1) {
          this.item.annotationWork = null
        }
      }
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchTopicModelItem () {
      this.axios.get(`/topic-models/${this.id}`)
        .then(response => {
          this.setTopicModelItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setTopicModelItem (item) {
      this.item = this.mapTopicModelItem(item)
    },
    mapTopicModelItem (item) {
      return {
        id: this.id,
        dataset: item.dataset,
        language: item.language.id,
        name: item.name,
        type: item.model_type,
        annotationWork: item.annotation_work,
        topics: item.topics.map((t) => {
          return {
            id: t.id,
            name: t.name,
            positiveSeedwords: t.positive_seedwords,
            negativeSeedwords: t.negative_seedwords,
            positiveInstances: t.positive_instances,
            negativeInstances: t.negative_instances,
            isActive: t.is_active,
            threshold: t.threshold * 100,
            precision: t.precision,
            recall: t.recall,
            fScore: t.f_score,
            matchingMethod: t.matching_method,
            topicModelType: t.use_supervised_topic_model ? 1 : 0,
            stemming: t.stemming_choice,
            modelPath: t.model_path
          }
        })
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        dataset: this.item.dataset,
        language: this.item.language,
        name: this.item.name,
        model_type: this.item.type,
        annotation_work: this.item.annotationWork
      }
      if (this.isNew) {
        this.axios.post('/topic-models', itemToSave)
          .then(response => {
            if (this.isNew) {
              this.item.id = response.data.id
              this.$router.replace({name: 'topicModelEdit', params: { id: this.item.id, stepProp: 1 }})
              this.step = 1
            } else {
              this.$router.go(-1)
            }
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/topic-models/${this.item.id}`, itemToSave)
          .then(response => {
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    deleteTopic () {
      this.deleteLoading = true
      this.axios.delete(`/topic-models/${this.id}/topics/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.item.topics.indexOf(this.itemToDelete)
          this.item.topics.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.deleteDialog = false
          this.itemToDelete = {}
        })
    },
    ...mapActions({
      setLoader: 'loader/setLoader'
    })
  }
}
</script>

<style>

</style>
